import React from "react";
import { Tooltip } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import ServiceBalancesItem from "./ServiceBalancesItem";
import PageSpinner from "../../elements/spinner/PageSpinner";

import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../styles/styledTable";
import { StyledTooltip } from "../../styles/styledTooltip";

const ServiceBalancesList = ({ serviceBalances }) => {
  const { t } = useTranslation("serviceBalancesPage");

  if (!serviceBalances) {
    return (
      <PageSpinner
        position="center"
        pt="20"
        pb="20"
      />
    );
  }

  if (serviceBalances.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="768"
        size="16"
        className="service-balances-table"
      >
        <StyledTableHead
          scroll="auto"
          col="2"
          className="service-balances-table__head"
        >
          <div>
            {t("table.service")}
          </div>
          <div>
            {t("table.cpBalance")}
            <Tooltip
              title={t("table.tooltips.cpBalance")}
              arrow
              placement="top"
            >
              <StyledTooltip className="icon-light-help" />
            </Tooltip>
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {serviceBalances && serviceBalances.map((value, key) => (
            <ServiceBalancesItem key={value.id} data={value} t={t} />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default ServiceBalancesList;